import { AppointmentData, PaymentStatus } from '../../models';

export const isPaid = (appointment: AppointmentData) => appointment.packId ||
    appointment.price <= (appointment?.payments?.filter(p => p.status === PaymentStatus.Manual || p.status === PaymentStatus.Success).map(p => p.value).reduce((prev, curr) => prev + curr, 0) || 0);
